import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import Header from '@cloudscape-design/components/header';
import SpaceBetween from '@cloudscape-design/components/space-between';
import React, { useEffect, useRef, useState } from 'react';
import { useGlobalState } from '../../../../context/GlobalStateContext';
import { CustomAppLayout } from '../../../layout';
import { useRouter } from '../../../router';
import { useStore } from '../../../store';
const _preserve = React.version;
//import { useStoreAdmin } from '../../../../context/useStoreAdmin';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelCheck from '../../../../../components/extras/SidePanelCheck';
import TableChecks from '../../../../../components/tables/tableChecks';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemCheck } from '../../../../../resources/types';
import { addNotification, addNotificationStatus, buildBreadcrumbItems, getCookie, getUrlVersion, setData, setLoading } from '../../../../commons/functions';


export const MembersEDVMyPendingChecksPage = () => {
  const [activeTab, setActiveTab] = useState("search");

  const {
    actions: { makeHelpPanelHandler },
  } = useStore();
  const { navigate } = useRouter();


  const { data } = useGlobalState();
  const [check, setCheck] = useState<ItemCheck>();
  const [mychecks, setMychecks] = useState<ItemCheck[]>([]);


  const { idUser, menu } = useGlobalState();
  const mountedRef = useRef(false);



  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      if (id) {
        if (!mountedRef.current) {
          mountedRef.current = true;
          handleCheckMine();
        }
        handleCheckGet(parseInt(id))
      } else {
        setCheck(undefined)
        handleCheckMine();
      }
    };
    window.addEventListener("hashchange", handleHashChange);
    handleHashChange();
    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);

  const handleCheckGet = async (idRequest: Number) => {
    try {
      setCheck(undefined)
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/admin/checks/requests/get',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          idRequest: idRequest
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setCheck(data.check);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }
  const handleCheckMine = async () => {
    try {
      setCheck(undefined);
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/checks/requests/search',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify({
          pending: true,
          orderBy: "dateSubmited",
          order: "desc",
        }),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setMychecks(data.checks);
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  const handleCheckEval = (idCheckParameter: string, opt: any) => {
    if (check && check.statusRequest == 1 && check.idInstructor == idUser && activeTab === "mychecks") {
      setCheck((prev: any) => ({
        ...prev,
        jsonResults: prev.jsonResults.map((item: any) =>
          item.idCheckParameter === idCheckParameter
            ? { ...item, resultValue: opt.value, resultText: opt.text }
            : item
        ),
      }));
    }
  };

  useEffect(() => {
    handleCheckMine()
  }, []);

  const handleCheckUpdate = async (check: any) => {
    try {
      setCheck(undefined)
      setLoading(true)
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/user/checks/requests/update',
          'JWT': getCookie("JWT"),
          //  
        },
        body: JSON.stringify(check),
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      addNotificationStatus(data, setData);
      if (data.code == 0) {
        setCheck(undefined);
        handleCheckMine();
      }
    } catch (error: any) {
      addNotification(`Error de red y/o comunicaciones: ${error.message}`, "error", setData);
    } finally { setLoading(false) }
  }

  type Tab = {
    label: string;
    id: string;
    content: React.ReactNode;
  };
  return (
    <CustomAppLayout
      toolsHide
      splitPanelOpen={!!check}
      onSplitPanelToggle={({ detail }) => !detail.open ? window.location.hash = "members/edv/checkrequests" : null}
      splitPanelSize={600}

      splitPanel={
        <SidePanelCheck Check={check}

          onUpdateCheck={(check) => {
            console.log(check)
            if (!!check && check.statusRequest === -1) {
              const updatedChecks = {
                idRequest: check.idRequest,
                statusRequest: check.statusRequest,
                cancelReason: check.cancelReason,
              }
              handleCheckUpdate(updatedChecks)


            }
          }}
        />

      }

      contentType="form"
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <>
          <SpaceBetween direction="vertical" size="xs">
            <Header actions={<Favorites />}
              description="Chequeos en los cuales usted debe ser evaluado">
              Mis chequeos pendientes
            </Header>


            <SpaceBetween direction='vertical' size='xs'>
              {mychecks && (

                <TableChecks checks={mychecks} onSelect={(item: ItemCheck) => window.location.hash = `members/edv/checkrequests?id=${item.idRequest}`}
                  showPilot={false} showInstructor showEval
                />


              )}
            </SpaceBetween>
          </SpaceBetween>



        </>
      }
    />
  );
};

function getColor(hex: string): "green" | "blue" | "red" | "grey" | "severity-low" {
  switch (hex.toLowerCase()) {
    case "#00b000":
      return "green";
    case "#007cff":
      return "blue";
    case "#ff0000":
      return "red";
    case "#999999":
      return "severity-low";
    default:
      return "grey";
  }
}